/*
 *   Copyright (c) 2021 Novumare Technologies
 *   All rights reserved.
 */
import React from "react";
import ReactDOM from "react-dom";
// import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/styles/tailwind.css";

// // layouts

// import Admin from "layouts/Admin.js";
// import Auth from "layouts/Auth.js";

// // views without layouts
// import Index from "views/Index.js";
// import Landing from "views/Landing.js";
// import Profile from "views/Profile.js";

import App from './App';


// language
import 'i18n'
// import "tailwindcss/tailwind.css"

// api
// import { sessionService } from 'redux-react-session';
import { applyMiddleware, createStore } from 'redux';
import ReduxThunk from 'redux-thunk';
import { Provider } from 'react-redux';
import reducers from './reducers';

const store = createStore(reducers, applyMiddleware(ReduxThunk));
// sessionService.initSessionService(store);

if (localStorage.getItem('userToken') === null) {
  localStorage.setItem('userToken', JSON.stringify({ auth: false }));
}




ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);
